import React, { Fragment } from 'react';
import { withRouter } from 'react-router-dom';
import { MenuContainer, MenuHeader, MenuButton, SeparatorWrapper, Separator, MenuBottom } from './style';
import { Icon } from '../Icons/Icons';
import { OuterIndent, HoverableLink, Row } from '../../Layouts';
import { handleLoginService } from '../../../Services/handleLocalStorage';
import { generateSlugLink } from '../../../Utils';
import { Text } from '../../UI/Text';
import { getCurrentFormattedDate } from '../../../Utils/timeConvertorHelper';
import { HoverableFadingContainer } from '../HoverableFadingContainer';
import { compose } from 'recompose';
import { config } from '../../../Configurations';
import { TinyAvatar } from '../../Containers/PlannedWorkouts/style';
import { withCurrentTime } from '../../Containers/HOCS/withCurrentTime';
import { timeFormats } from '../../../Constants/timeFormats';

let Menu = ({ match, onLogout, currentTime, user: { smallImage, fullName } }) => {
    const urlBase = match.url;
    const name = handleLoginService.getFullName();
    const id = handleLoginService.getUserId();

    const membershipLinks = [
        { pathname: `${urlBase}`, title: 'Members', exact: true },
        { pathname: `${urlBase}/membership-types`, title: 'Membership types' },
        { pathname: `${urlBase}/calendar`, title: 'Calendar' },
        { pathname: `${urlBase}/gym-tv`, title: 'Gym TV' },
    ];

    const profileLinks = [
        { pathname: '/check-in', title: 'Check In' },
        { pathname: `/${generateSlugLink({ name, id })}`, title: 'Public Profile' },
        { pathname: '/planner', title: 'Workout Planner' },
        { pathname: `/${generateSlugLink({ name, id })}/planned`, title: 'Planned Workouts' },
    ];

    return (
        <MenuContainer>
            <MenuHeader>
                <OuterIndent indent={'0 0 12px 0'}>
                    <HoverableLink target={'_blank'} to={`/${generateSlugLink({ name, id })}`}>
                        <Icon.Box size={'35x20'}>
                            <Icon.Logo />
                        </Icon.Box>
                    </HoverableLink>
                </OuterIndent>

                <OuterIndent indent={'0 0 0 5px'}>
                    <Row>
                        <TinyAvatar image={`${config.baseUrl}/${smallImage}`} />
                        <Text opacity={0.9} weight={100} fontSize={12} marginLeft={'5px'}>
                            {fullName}
                        </Text>
                    </Row>
                </OuterIndent>
            </MenuHeader>

            <Links membershipLinks={membershipLinks} profileLinks={profileLinks} />

            <MenuBottom>
                <Text fontSize={12} weight={100} opacity={0.7} marginBottom={'10px'}>
                    {getCurrentFormattedDate(timeFormats.DAY_ORDER_MON_YEAR)} {currentTime}
                </Text>
                <HoverableFadingContainer>
                    <Text onClick={onLogout} cursor={'pointer'} fontSize={16} weight={100} opacity={0.9}>
                        Sign out 👋
                    </Text>
                </HoverableFadingContainer>
            </MenuBottom>
        </MenuContainer>
    );
};

Menu.defaultProps = {
    user: {
        smallImage: '',
        fullName: 'Your account',
    },
};

export const SideMenu = compose(
    withCurrentTime,
    withRouter,
)(Menu);

const Links = ({ membershipLinks, profileLinks }) => (
    <Fragment>
        {membershipLinks.map((link, index) => (
            <MenuButton key={`${index}-inner`} exact={link.exact} to={link.pathname}>
                <div>{link.title}</div>
            </MenuButton>
        ))}

        <SeparatorWrapper>
            <Separator />
        </SeparatorWrapper>

        {profileLinks.map((link, index) => (
            <MenuButton key={`${index}-outer`} target={'_blank'} to={link.pathname}>
                <div>{link.title}</div>
            </MenuButton>
        ))}
    </Fragment>
);



// WEBPACK FOOTER //
// ./src/UI/Components/AdminSideMenu/index.js